<div class="col-md-12 bg-white mt-3 p-2 rounded">
    <form class="form-inline float-right mt-3  bg-white">
        <div class="d-flex pr-4 text-black">
          <a class="btn  btn-sm text-white bg-dark" (click)='backClicked()' translate ><i class="fa fa-times"></i> BACK</a>
        </div>
      
        <div class="d-flex pr-4 text-white">
          <a class="btn text-white btn-sm mx-1 bg-dark" (click)='editSchedule(userschedule[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate ><i class="fa fa-times"></i> EDIT</a>
         
        </div>
    
    
        <div class="d-flex pr-4 text-white">
          
            <a class="btn text-white btn-sm  bg-dark" (click)='deleteSchedule(userschedule[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()"  translate><i class="fa fa-times"></i> DELETE</a>
          </div>
        </form>
        
        <section class="content-header mt-5 d-flex justify-content-between p-3 pt-1 align-items-center mx-2 bg-white">
            <h3 translate>Appointment<h5> Details</h5>
            </h3>
    
            <ol class="breadcrumb bg-transparent bg-white">
                <li class="breadcrumb-item " style="font-size: 12px; " translate>Home</li>
                <li class="breadcrumb-item" style="font-size: 12px; " translate> Schedule Details</li>
            </ol>
    
    </section>
    </div>
    
    
    
    
    <section class="container-fluid p-0 w-100 ">
        <div class="row w-100 m-0 ">    
      
            <div class="col-xs-12 w-100">
                
                <div class="box box-primary  border-top  shadow-lg bg-transparent w-100">
                   
                    <div class="box-header m-2 border-bottom w-100 row d-flex justify-content-between" *ngFor='let user of userschedule'>
                        <h3 class="p-2"><strong>{{fullName}}</strong></h3>
                       <h4 class=" bg-warning text-white mx-3 p-2 rounded" *ngIf="user.status=='Pending'">{{user.status}}</h4>
                       <h4 class=" bg-primary text-white mx-3 p-2 rounded" *ngIf="user.status=='In Progress'">{{user.status}}</h4>
                       <h4 class=" bg-danger text-white mx-3 p-2 rounded" *ngIf="user.status=='Cancelled'">{{user.status}}</h4>
                       <h4 class=" bg-success text-white mx-3 p-2 rounded" *ngIf="user.status=='Completed'">{{user.status}}</h4>
                    <!--    <div class="row mx-2">
                        <button class="btn btn-dark mx-2" (click)=patchCheckIn()>Check In</button>
    
                        <button class="btn btn-dark mx-2" (click)=patchCheckOut()>Check Out</button>
                    </div>-->
    
                    </div>
    
    
    
    
                   
    
    
                    <div class="box-body  " style="background-color: #f5f7fa;">
                        <div class="container-fluid   p-2">
    
    
    
                            <div class=" row flex-row justify-content-around  m-1"  >
                                <div class="flex-column col-sm-4 box box-primary  border-top border-primary shadow-sm bg-white   p-3"
                                    style="max-width:100%; min-width: 32%; font-family:Trebuchet MS; " *ngFor='let user of userschedule'>
                                    <label *ngIf="user.describesYou!='Homeowner'"  class="d-flex justify-content-between" >
                                        <h6 class="d-flex"><strong translate>Email</strong></h6>
                                        <h6><span class="float-right">{{user.email}}<br></span>
                                        </h6>
                                    </label>
    
                                    <label class="d-flex justify-content-between" *ngFor='let user of userschedule'>
                                        <h6 class="d-flex"><strong translate>Phone</strong></h6>
                                        <h6><span
                                                class="d-flex float-right">{{user.phoneNumber}}<br></span></h6>
                                    </label>
    
                                    <label class="d-flex justify-content-between" *ngFor='let user of userschedule'>
                                        <h6 class="d-flex"><strong translate>Branch</strong></h6>
                                        <h6><span
                                                class="d-flex float-right">{{user.branch}}<br></span></h6>
                                    </label>
    
                                   
    
                         
    
                                </div>
    
                                <div class="flex-column col-sm-4 box box-primary border-top border-primary shadow-sm bg-white p-3 " 
                                    style="max-width:100%; min-width: 25%; font-family:Trebuchet MS; " *ngFor='let user of userschedule'>
                                  
                                    <label class="text-bold">
                                        <h3 translate>Sales Representation</h3>
                                    </label><br>
                                    <h5 class="float-right">{{user.salesRep}}          </h5>
                                      
                                   
    
                                </div>
    
                                <div class="d-flex flex-column justify-content-between col-sm-4 box box-primary border-top  border-primary shadow-sm bg-white   p-3 "
                                    style="max-width:100%; min-width: 32%; font-family:Trebuchet MS;">
                                    <label class="d-flex justify-content-between" *ngFor='let user of userschedule'>
                                        <h6 class="d-flex"><strong translate>Pick Up Time</strong></h6>
                                        <h6><span
                                                class="d-flex float-right">{{user.pickupTime | date:'yyyy-M-d h:mm a'}}<br></span></h6>
                                    </label>
    
                                    <label class="d-flex justify-content-between" *ngFor='let user of userschedule'>
                                        <h6 class="d-flex"><strong translate>Check Out</strong></h6>
                                        <h6><span
                                                class="d-flex float-right">{{user.checkOut | date:'yyyy-M-d h:mm a'}}<br></span></h6>
                                    </label>
    
                                    <label class="d-flex justify-content-between" *ngFor='let user of userschedule'>
                                        <h6 class="d-flex"><strong translate>Date Submitted</strong></h6>
                                        <h6><span class="float-right">{{user.dateSubmitted  | date:'yyyy-M-d h:mm a'}}<br></span>
                                        </h6>
                                    </label>
                                </div>
    
                            </div>
    
    
    
    
    
                            <div class="row d-flex justify-content-between w-100 m-1">
                                
                             
    
    
                                
                                <div class="col-sm-6 d-flex flex-column justify-content-between  box box-primary border-top border-primary shadow-sm bg-white p-3 "*ngFor='let user of userschedule' 
                                    style="max-width:100%; min-width: 33%; ">
                                  
                                    <label class="d-flex " *ngFor='let user of userschedule'>
                                        <h6 class="d-flex"><strong translate>Invoice #</strong></h6>
                                        <h6><span
                                                class="d-flex float-right">{{user.invoiceNumber}}<br></span></h6>
                                    </label>
    
                                
                                    <label class="" *ngFor='let user of userschedule'>
                                        <h6 class="d-flex"><strong translate>Order Description</strong></h6>
                                        <h6><span
                                                class="d-flex float-left">{{user.orderDescription}}<br></span></h6>
                                    </label>
                                  
    
                                   
                                </div>
    
    
    
                                <div class="col-sm-6 d-flex flex-column justify-content-between  box box-primary border-top border-primary shadow-sm bg-white p-3 "*ngFor='let user of userschedule' 
                                style="max-width:100%; min-width: 33%; ">
                              
                                <label class="" *ngFor='let user of userschedule'>
                                    <h6 class="d-flex"><strong translate>Notes</strong></h6>
                                    <h6><span
                                            class="d-flex float-left">{{user.notes}}<br></span></h6>
                                </label>
    
                                
                            </div>
    
    
                            </div>
    
    
    
                        </div>
                    
    
    
    
    
    
    
                    
              <!--      <div class="box-header m-2 border-bottom" >
                        <h5><strong>Services/Action Performed</strong>
                        <a class="btn btn-dark btn-sm mr-2 text-white float-right" *ngIf="perms===true" (click)="onAddWorksheet(assetviewmodel)"
        routerLinkActive="blue"><i class="fa fa-plus"></i> ADD</a></h5>
                       
                    </div>
    
                </div>
                        <div class="table-responsive" *ngIf='worksheetDetails!==[]'>
                            <div class="asset-table">
                                <table id="dataTablesFull" class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Details</th>
                                            <th>Date</th>
                                            <th>Issuer</th>
                                            <th>Status</th>
                                            <th class="text-right"> </th>
                                        </tr>
                                    </thead>
                                -->
                                    
                                    <!--gets all the assets from assets table-->
                             <!--       <tbody  *ngFor='let worksheet of worksheetDetails' >
                                        
                                        <tr >
                                            <td class="text-info" *ngIf="perms===true; else elseBlock1 " (click)="onWorksheetSelect(worksheet)">
                                                {{worksheet.PID}}
                                            </td>
                                            <ng-template #elseBlock1>
                                                <td >{{worksheet.PID}}</td>
                                            </ng-template>
        
        
                                            <td class="text-info" (click)="onWorksheetSelect(worksheet.PID)" *ngIf="perms===true; else elseBlock2 ">
                                                {{worksheet.service}}
                                            </td>
                                            <ng-template #elseBlock2>
                                                <td>{{worksheet.service}}</td>
                                            </ng-template>
        
        
                                            <td >
                                                {{worksheet.details}}
                                            </td>
                                           
        
        
                                            <td>
                                                {{worksheet.date}}
                                            </td>
                                            
        
        
                                            <td>
                                                {{worksheet.issuer}}
                                            </td>
        
                                            
        
                                            <div [ngSwitch]="worksheet.status">
                                                <td class="badge bg-primary text-light m-1" *ngSwitchCase="'Completed'">
                                                    {{worksheet.status}}</td>
                                                <td class="badge bg-warning text-light" *ngSwitchCase="'Pending Approval'">
                                                    {{worksheet.status}}</td>
                                                <td class="badge bg-danger text-light" *ngSwitchCase="'Declined'">{{worksheet.status}}
                                                </td>
                                                <td class="badge bg-info text-light" *ngSwitchCase="'Processing'">{{worksheet.status}}
                                                </td>
    
                                                <td class="badge bg-info text-light" *ngSwitchCase="'Partial Completed'">{{worksheet.status}}
                                                </td>
                                            </div>
        
        
                                            <td *ngIf="perms===true; ">
                                                
                                                <i class="fa fa-trash p-1"  data-toggle="modal" data-target="#deleteModal"></i><i
                                                    class="fa fa-edit text-info p-1" (click)="openModal(editProfileModal, asset)"></i>
                                            </td>
                                            
                                        
    -->
    
    
    
                             
                                            
        
        <!---------- Delete Modal ------------------------------------------------------------------------------------------------------------>
                 <!--                           <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog"
                                                aria-labelledby="deleteModalLabel" aria-hidden="true">
                                                <div class="modal-dialog" role="document">
                                                    <div class="modal-content">
                                                        <div class="modal-header">
                                                            <h5 class="modal-title" id="deleteModalLabel">
                                                                <strong>DELETE</strong></h5>
                                                            <button type="button" class="close" data-dismiss="modal"
                                                                aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">
                                                            Are you you want to delete <br>
                                                            <strong>ID :</strong> {{worksheet.pid}}<br>
                                                            <strong>Service :</strong> {{worksheet.service}}<br>
                                                            <strong>Date :</strong> {{worksheet.date}}
                                                        </div>
                                                        <div class="modal-footer">
                                                            <button type="button" class="btn btn-secondary"
                                                                data-dismiss="modal">Close</button>
                                                            <button type="button" (click)=actionDelete(asset.id,asset.department);
                                                                data-dismiss="modal" class="btn btn-primary">Delete</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
        <!------------------------------------------------------------------------------------------------------------------------------------------>
        
                              <!--          </tr>
                                    </tbody>
        
                                </table>
                            </div>-->
                        </div>
                
    
    
    
    
    
                </div>
            </div>
        </div>
    
    </section>
    
    
    
    <!------------------------------------------------------------------------------------------------------------------------------------------
                            Success DeleteModal
                        ------------------------------------------------------------------------------------------------------------------------------------------>
                        <button id="openSuccessDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessDeleteModal">Open Modal</button>
                        <!-- Modal -->
                        <div id="SuccessDeleteModal" class="modal fade" role="dialog">
                            <div class="modal-dialog">
                        
                                <!-- Modal content-->
                                <div class="modal-content">
                                    <div class="modal-header">
                        
                                   <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                        <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                    </div>
                                    <div class="modal-body " style="background: black;">
                                        <div class="row p-5 ">
                                            <div class="col-sm-12 w-100">
                                                <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                        
                        
                                                    <img class="px-3"
                                                        style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                        src="./assets/logo2020w.png" />
                        
                                                    <div class="w-100 text-center">
                                                        <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                    </div>
                        
                                                    <div class="border  bg-white "></div>
                                                    <div class="w-100 text-center">
                                                        <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment has been deleted.</h4>
                                                    </div>
                        
                                                   
                        
                        
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-default text-center" routerLink='/main-dashboard' data-dismiss="modal" translate>Close</button>
                                    </div>
                                </div>
                        
                            </div>
                        </div>
                        
                        
                        <!------------------------------------------------------------------------------------------------------------------------------------------
                                               Error Modal
                                            ------------------------------------------------------------------------------------------------------------------------------------------>
                        <button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
                        <!-- Modal -->
                        <div id="ErrorModal" class="modal fade" role="dialog">
                            <div class="modal-dialog">
                        
                                <!-- Modal content-->
                                <div class="modal-content">
                                    <div class="modal-header">
                        
                                        <h4 class="modal-title text-danger" translate>ERROR</h4>
                                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    </div>
                                    <div class="modal-body text-danger">
                                        <p>{{error}}</p>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-default" routerLink='/main-dashboard' data-dismiss="modal" translate>Close</button>
                                    </div>
                                </div>
                        
                            </div>